module.exports = __webpack_public_path__ + "static/media/PTLocationSearch.8fb74ca0.png";